function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.7316 7.76466L14.0161 11.5561L14.8931 16.9079C14.976 17.4171 14.6494 17.9 14.1627 17.9868C13.9692 18.0211 13.7705 17.9881 13.597 17.8933L9.00139 15.365L4.40711 17.892C3.96992 18.1321 3.42987 17.9558 3.20035 17.4985C3.10906 17.3169 3.07755 17.109 3.11099 16.9066L3.98664 11.5561L0.269936 7.76601C-0.083668 7.4055 -0.0907401 6.81361 0.253863 6.44368C0.391448 6.29639 0.570821 6.2002 0.765625 6.17128L5.90189 5.3904L8.19903 0.52147C8.41698 0.0587233 8.95253 -0.131622 9.39486 0.0963887C9.57166 0.187189 9.71438 0.337178 9.80118 0.52147L12.0983 5.3904L17.2346 6.17128C17.7232 6.24527 18.0614 6.71945 17.9907 7.23062C17.9624 7.43375 17.8717 7.6214 17.7316 7.76466Z"
});

function SvgIconHighlights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHighlights);
export default __webpack_public_path__ + "static/media/icon-highlights.3c0e93ab.svg";
export { ForwardRef as ReactComponent };